<template>
    <div>
        <div class="menu-item" v-for="(menu_item, m_index) in accessibleMenuItems " :key="m_index"
             :class="isUrl(menu_item.url) ? ' active' : ''"
             v-on="menu_item.submenu?{click: (e) => addActiveClass(e)}:{}"
        >
            <Link class="flex items-center group py-3 menu-link" :href="menu_item.route?route(menu_item.route):'#'"
                  :class="{'have-sub-menu': menu_item.submenu}"
            >
                <icon :name="menu_item.icon" class="w-6 h-6 mr-3 rtl:ml-3 menu__icon"/>
                <div class="menu__name">{{ __(menu_item.name) }}</div>
            </Link>
            <div v-if="menu_item.submenu" class="sub-menu-items">
                <Link class="sub-menu-item" v-for="(sub_menu_item, s_m_index) in menu_item.submenu" :key="s_m_index"
                      :class="this.isUrl(sub_menu_item.url) ? ' active' : ''"
                      :href="sub_menu_item.param?route(sub_menu_item.route,sub_menu_item.param):route(sub_menu_item.route)"
                >
                    <icon v-if="sub_menu_item.icon" :name="sub_menu_item.icon"
                          class="w-4 h-4 mr-1 rtl:ml-1 menu__icon"
                    />
                    <icon v-else name="dash" class="w-4 h-4 mr-1 rtl:mr-1 menu__icon"/>
                    <div class="menu__name">{{ __(sub_menu_item.name) }}</div>
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import {Link} from '@inertiajs/vue3'

export default {
    components: {
        Icon,
        Link,
    },
    props:{
    },
    data() {
        return {
            user: null,
            menu_items: [
                {'name': 'Add Interview', 'route': 'admin.addInterview', 'url': 'admin/add-interview', 'icon': 'users', 'permission' : 'add_interview'},
                {'name': 'Interview List', 'route': 'admin.interviewList', 'url': 'admin/interview-list', 'icon': 'users', 'permission' : 'view_interview_list'},
                {'name': 'Staff List', 'route': 'admin.staffList', 'url': 'admin/staff_list', 'icon': 'users', 'permission' : 'view_staff_list'},
                {'name': 'New Ticket', 'route': 'admin.addTicket', 'url': 'admin/add-ticket', 'icon': 'users', 'permission' : 'add_ticket'},
                {'name': 'Ticket List', 'route': 'admin.ticketList', 'url': 'admin/ticket-list', 'icon': 'users', 'permission' : 'view_ticket_list'},
                {'name': 'Attendance', 'route': 'admin.attendance', 'url': 'admin/attendance', 'icon': 'users', 'permission' : 'view_ticket_list'},
                {'name': 'Add Draft', 'route': 'admin.addDraft', 'url': 'admin/add-draft', 'icon': 'users', 'permission' : 'add_draft'},
                {'name': 'Draft List', 'route': 'admin.draftList', 'url': 'admin/draft-list', 'icon': 'users', 'permission' : 'view_draft_list'},
                {'name': 'Add Scheduler', 'route': 'admin.addScheduler', 'url': 'admin/add-scheduler', 'icon': 'users', 'permission' : 'add_scheduler'},
                {'name': 'Scheduler List', 'route': 'admin.schedulerList', 'url': 'admin/scheduler-list', 'icon': 'users', 'permission' : 'view_scheduler_list'},
                {'name': 'Chat', 'route': 'admin.chatView', 'url': 'admin/chat', 'icon': 'users', 'permission' : 'access_chat'},
                {'name': 'Roles', 'route': 'roles', 'url': 'settings/roles', 'icon': 'users', 'permission' : 'view_role_list'},
            ],
            enable_option: {},
        }
    },
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            currentUrl = currentUrl.replace('dashboard/', '')
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter(url => currentUrl.startsWith(url)).length
        },
        addActiveClass(e) {
            e.currentTarget.classList.toggle('hover')
        },
    },
    created() {
        this.user = this.$page.props.auth.user
    },
    computed: {
        accessibleMenuItems() {
            return this.menu_items.filter(item => this.$page.props.auth_permissions.includes(item.permission));
        }
    }
}
</script>
